<script setup>
import { onMounted, ref } from 'vue';
import { fetchData } from '../../fetchData';
import ColumnBannerItem from './ColumnBannerItem.vue';
import ColumnBannerItemSkeleton from './ColumnBannerItemSkeleton.vue';

const props = defineProps({
    index: Number,
    iteration: Number
});

const limit = ref(3);
const loading = ref(false);
const error = ref(null);
const posts = ref([]);
const isLargeScreen = ref(window.innerWidth >= 1024);

const fetchNews = async () => {
    if (!isLargeScreen.value) return;

    try {
        loading.value = true;
        error.value = null;

        const params = new URLSearchParams({
            page: props.iteration + 2,
            limit: limit.value,
            highlighted: true,
            'sort[by]': 'published_at',
            'sort[order]': 'desc'
        });

        const { result = {}, pending } = await fetchData(`/api/v1/posts?${params.toString()}`);
        loading.value = pending;
        posts.value = result.data;
    } catch (e) {
        error.value = e.message;
    } finally {
        loading.value = false;
    }
};

onMounted(() => {
    fetchNews();
    window.addEventListener('resize', () => {
        isLargeScreen.value = window.innerWidth >= 1024;

        if (isLargeScreen.value) fetchNews();
    });
});
</script>

<template>
    <div v-if="isLargeScreen" class="grid gap-4 mt-12 mb-8" :class="`grid-cols-${limit}`">
        <ColumnBannerItemSkeleton v-for="n in limit" v-if="loading" :key="`sk-load-${n}`" />
        <ColumnBannerItem v-for="post in posts" v-else :key="post.id" :post="post" />
    </div>
</template>
